import Button from '@mui/material/Button'
import Icon from '@mui/material/Icon'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

type Props = {
  icon?: string
  linkText?: string
  link?: string
  subtitle?: string
  title?: string

  callback?: (() => void) | null
}

export default function CatiErrorLayout(props: Props) {
  const { icon, link, linkText, subtitle, title } = props

  return (
    <PageContainer>
      <BoxContainer>
        <Icon color="primary" sx={{ fontSize: '6rem !important' }}>
          {icon}
        </Icon>
        <Typography sx={{ mt: '20px' }} variant="h4">
          {title}
        </Typography>
        {subtitle && (
          <Typography color="textSecondary" variant="h6">
            {subtitle}
          </Typography>
        )}
        {props.callback && (
          <Button sx={{ mt: '30px' }} variant="contained" color="primary" onClick={props.callback}>
            {linkText}
          </Button>
        )}
        {link && (
          <Button sx={{ mt: '30px' }} variant="contained" color="primary" href={link}>
            {linkText}
          </Button>
        )}
      </BoxContainer>
    </PageContainer>
  )
}

const PageContainer = styled('div')({
  textAlign: 'center',
  marginTop: '70px',
})

const BoxContainer = styled('div')({
  width: '30vw',
  textAlign: 'center',
  margin: 'auto',
  boxShadow: '0px 0px 0px 1px rgb(224 224 224)',
  padding: '30px',
})
